import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IParseProduct, IQuotationDetail } from '../../models/quotations.models';
import { SetQuotationsLoader } from '../../store/quotations.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { QuotesService } from '../../services/quotations.services';
import { QuotationExportService } from '../../services/quotation-export.service';
import { environment } from 'src/environments/environment';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import { ProductCodeService } from 'src/app/core/services/product-code.service';

@Component({
  selector: 'app-preview-quote',
  templateUrl: './preview-quote.component.html',
  styleUrls: ['./preview-quote.component.scss']
})
export class PreviewQuoteComponent {
  placeholder: string = 'assets/icones/default-image-product.svg';
  baseUrl = environment.BASE_URL_API;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IQuotationDetail,
    private dialogRef: MatDialogRef<PreviewQuoteComponent>,
    private store: Store<AppState>,
    private services: QuotesService,
    private exportService: QuotationExportService,
    public featureFlags: FeatureFlagService,
    public productCode: ProductCodeService,
  ) { }

  downloadFileCSV(): void {
    const isOrder = this.data.status === 'sale' || this.data.status === 'done';
    this.exportService.downloadProductsCsv(this.data.products, `${isOrder ? 'order' : 'quotation'}-${this.data.id}.csv`);
  }

  compareProducts(current: IQuotationDetail, parent: IQuotationDetail) {
    const addedProducts: IParseProduct[] = current.products.filter(product => !parent.products.some(p => p.id === product.id));
    const removedProducts: IParseProduct[] = parent.products.filter(product => !current.products.some(p => p.id === product.id));
    const changedQuantityProducts = current.products.map(cp => {
      const pp = parent.products.find(p => p.id === cp.id);
      if (pp && pp.quantity !== cp.quantity) {
        return { product: cp, previousQuantity: pp.quantity };
      }
      return null;
    }).filter(pp => pp !== null) as { product: IParseProduct, previousQuantity: number }[];


    const changedPriceProducts = current.products.map(cp => {
      const pp = parent.products.find(p => p.id === cp.id);
      if (pp && pp.price_unit !== cp.price_unit) {
        return { product: cp, previousPrice: pp.price_unit };
      }
      return null;
    }).filter(pp => pp !== null) as { product: IParseProduct, previousPrice: number }[];

    return { addedProducts, removedProducts, changedQuantityProducts, changedPriceProducts };
  }


  isAddedProduct(product: IParseProduct): boolean {
    if (!this.data.parent) {
      return false;
    }
    return !this.data.parent!.products.some(p => p.id === product.id);
  }

  getOldQuantity(product: IParseProduct): number {
    if (!this.data.parent) {
      return product.quantity;
    }
    const parentProduct = this.data.parent!.products.find(p => p.id === product.id);
    return parentProduct ? parentProduct.quantity : product.quantity;
  }

  getOldPrice(product: IParseProduct): number {
    if (!this.data.parent) {
      return this.getUnitPrice(product);
    }
    const parentProduct = this.data.parent!.products.find(p => p.id === product.id);
    return parentProduct ? this.getUnitPrice(parentProduct) : this.getUnitPrice(product);
  }

  getOldDiscount(product: IParseProduct): number {
    if (!this.data.parent) {
      return product.discount;
    }
    const parentProduct = this.data.parent!.products.find(p => p.id === product.id);
    return parentProduct ? parentProduct.discount : product.discount;
  }


  getDeletedProducts(): IParseProduct[] {
    if (!this.data.parent) {
      return [];
    }

    return this.data.parent.products.filter(parentProduct =>
      !this.data.products.some(product => product.id === parentProduct.id)
    );
  }

  getUnitPrice(product: IParseProduct): number {
    const price = product.price_unit ? product.price_unit : 0;

    return price;
  }

  getFinalPrice(product: IParseProduct): number {
    const price = product.final_price ? product.final_price : (product.price_unit * (1 - product.discount / 100));

    return price;
  }

  getOldFinalPrice(product: IParseProduct): number {
    if (!this.data.parent) {
      return this.getFinalPrice(product);
    }

    const parentProduct = this.data.parent!.products.find(p => p.id === product.id);
    return parentProduct ? this.getFinalPrice(parentProduct) : this.getFinalPrice(product);
  }

  getTotalAmount(product: IParseProduct): number {
    return product.total;
  }

  getOldTotalAmount(product: IParseProduct): number {
    if (!this.data.parent) {
      return product.total;
    }

    const parentProduct = this.data.parent!.products.find(p => p.id === product.id);
    return parentProduct ? parentProduct.total : product.total;
  }

  getQuotationTotalPrice(quotation: IQuotationDetail) {
    return quotation ? quotation.products.reduce((acc, product) => {
      return acc + this.getTotalAmount(product)
    }, 0) : 0
  }

  downloadFile() {
    this.store.dispatch(SetQuotationsLoader({ isLoading: true }));

    this.services.getPdfQuotation(this.data.id).subscribe({
      next: (res) => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
        const blob = new Blob([res], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      },
      error: () => {
        this.store.dispatch(SetQuotationsLoader({ isLoading: false }));
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
